/**
 * O objetivo dessa classe é armazenar o contrato de um tracker, dessa forma garantimos que sempre que
 * formos adicionar um novo mecanismo ele implemente o contrato utilizado pela classe que irá de fato
 * chamar os eventos
 */
export abstract class AbstractTracker {
  settings: { user?: string } = {};

  abstract trackEvent(parameters: TrackEventParameters): void;
  abstract peopleSetOnce(event: string, parameter: any): void;
  abstract peopleSet(event: string, parameter: any): void;
  abstract identify(identifier: string): void;
  abstract register(parameters: object): void;
}

export interface TrackEventParameters {
  event: string;
  parameters?: object;
}
